/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonCancel.vue?vue&type=template&id=8c1ac282"
import script from "./ButtonCancel.ts?vue&type=script&lang=ts&external"
export * from "./ButtonCancel.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports